module.exports = __webpack_public_path__ + "img/image-not-available.e546e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/devices/image-not-available.png
// module id = 5gVB
// module chunks = 38 43